import * as Yup from 'yup'

export interface ICreateConditioning {
  description?: string
  conditioning_number?: string
  conditioning_cost?: string
  character?: 'imposing' | 'informative'
  observation?: string
  start_date?: string
  conclusion_date?: string
  limit_date?: string
  status?: 'not_started' | 'in_progress' | 'done' | ''
  annuity?: boolean
  id?: number
  alert_days: number[]
  uuid?: string
  license_id?: number
  email?: string
  provider_id?: number
  responsible_id?: number[]
  responsibles?: any
  response_report?: string

  initials?: {
    label: string
    state: string
  }

  license?: {
    license_number?: string
    uuid?: string
  }

  tags?: any[]

  conditioning_files?: [
    {
      name?: string
      size?: string
    }
  ]
  path?: [
    {
      name: string
      size: string
    }
  ]
}

const createConditioningsSchemas = [
  Yup.object({}),
  // Yup.object({
  //   description: Yup.string().required('Campo obrigatório'),
  //   conditioning_number: Yup.string().required('Campo obrigatório'),
  //   responsible_id: Yup.array().min(1, 'Campo obrigatório'),
  // }),
  // Yup.object({
  //   // annuity: Yup.boolean().required('Campo obrigatório'),
  //   // status: Yup.string().required('Campo obrigatório'),
  //   // character: Yup.string().required('Campo obrigatório'),
  //   alert_days: Yup.array().min(1, 'Campo obrigatório'),
  //   start_date: Yup.string().min(4, 'Campo obrigatório'),
  // }),
]

const inits: ICreateConditioning = {
  description: '',
  email: '',
  conditioning_number: '',
  alert_days: [],
  annuity: false,
  responsible_id: [],
  character: 'imposing',
  status: '',
  start_date: '',
  conclusion_date: '',
}

export {createConditioningsSchemas, inits}
